<template>
  <div class="fixed-grid has-2-cols-desktop has-1-cols-mobile">
    <div class="grid">
      <div class="cell is-flex">
        <article class="box is-flex-grow-1">
          <div class="mb-6">
            <div class="columns mb-0">
              <div class="column">
                <p class="title mb-2">To Be Invoiced</p>
              </div>
              <div class="column">
                <button class="button is-small is-info is-pulled-right"
                  @click="openSummaryModal">
                  <span class="icon">
                    <i class="mdi mdi-eye" />
                  </span>
                  <span>
                    View Summary
                  </span>
                </button>
              </div>
            </div>

            <div>
              <p v-if="toBeInvoiceAssessments.length > 0"
                class="is-size-7">Select jobs to raise invoice/s</p>
              <table class="table is-fullwidth">
                <thead>
                  <tr>
                    <th>{{ columnsToBeInvoiced[0] }}</th>
                    <th>{{ columnsToBeInvoiced[1] }}</th>
                    <th class="has-text-right">{{ columnsToBeInvoiced[2] }} <p class="is-size-8">Ex GST</p>
                    </th>
                    <th class="has-text-right">{{ columnsToBeInvoiced[3] }} <p class="is-size-8">Ex GST</p>
                    </th>
                    <th class="has-text-right">{{ columnsToBeInvoiced[4] }} <p class="is-size-8">Ex GST</p>
                    </th>
                    <th>{{ columnsToBeInvoiced[5] }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="assessment in toBeInvoiceAssessments"
                    :key="assessment.subQuoteNo">
                    <td class="has-vertical-middle">{{ assessment.subQuoteNo === 0 ? 'Main' : `Supp-${assessment.subQuoteNo}` }}</td>
                    <td class="has-vertical-middle">{{ $filters.formatDateTimezone(assessment.authorisedAssessment.createdDate, $userInfo.locale) }}</td>
                    <td class="has-vertical-middle has-text-right money-input">{{ $filters.formatCurrency(assessment.quotedAmount, $userInfo.locale) }}</td>
                    <td class="has-vertical-middle has-text-right money-input">{{ $filters.formatCurrency(assessment.authorisedAmount, $userInfo.locale) }}</td>
                    <td class="has-vertical-middle has-text-right money-input">{{ $filters.formatCurrency(assessment.invoicedAmount, $userInfo.locale) }}</td>
                    <td class="has-vertical-middle has-text-centered is-content-width">
                      <div class="pretty p-icon p-curve p-smooth m-0 p-bigger">
                        <input v-model="assessment.selected"
                          @click="onAssessmentSelect($event, assessment)"
                          :disabled="cannotRaiseInvoice"
                          type="checkbox"
                          :class="{ 'is-disabled': cannotRaiseInvoice }">
                        <div class="state p-primary">
                          <i class="icon mdi mdi-check" />
                          <label />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="toBeInvoiceAssessments.length === 0">
                    <td :colspan="columnsToBeInvoiced.length">
                      <div class="content has-text-grey has-text-centered">
                        <span icon="icon is-large">
                          <i class="mdi mdi-48px mdi-emoticon-sad" />
                        </span>
                        <p>Nothing</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div>
            <p class="title mb-2">Raised Invoices</p>
            <div>
              <p v-if="innerValue.invoices.length > 0"
                class="is-size-7">Select invoice to view details</p>
              <table class="table is-fullwidth">
                <thead>
                  <tr>
                    <th>{{ columnsRaisedInvoices[0] }}</th>
                    <th>{{ columnsRaisedInvoices[1] }}</th>
                    <th>{{ columnsRaisedInvoices[2] }}</th>
                    <th>{{ columnsRaisedInvoices[3] }}</th>
                    <th class="has-text-right">{{ columnsRaisedInvoices[4] }}</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="invoice in raisedInvoice"
                    :key="invoice.invoiceId"
                    :class="invoice.isSelected ? 'has-text-primary' : ''">
                    <td class="has-vertical-middle">{{ invoice.invoiceNo }}</td>
                    <td class="has-vertical-middle">{{ $filters.formatDateTimezone(invoice.invoiceDate, $userInfo.locale) }}</td>
                    <td class="has-vertical-middle">{{ invoice.assetName }}</td>
                    <td class="has-vertical-middle">{{ invoiceTypeName(invoice.invoiceType) }}</td>
                    <td class="has-vertical-middle has-text-right money-input">{{ $filters.formatCurrency(invoice.totalIncGst, $userInfo.locale) }}</td>
                    <td class="has-vertical-middle has-text-centered is-content-width">
                      <div class="icon-container">
                        <button class="button is-primary is-small is-inverted tooltip"
                          @click="onSelectInvoice(invoice)"
                          data-tooltip="View Details">
                          <span class="icon is-small">
                            <i class="mdi mdi-eye mdi-24px"
                              :class="invoice.isSelected ? '' : 'mdi-inactive-color'" />
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="raisedInvoice.length === 0">
                    <td :colspan="columnsRaisedInvoices.length">
                      <div class="content has-text-grey has-text-centered">
                        <span icon="icon is-large">
                          <i class="mdi mdi-48px mdi-emoticon-sad" />
                        </span>
                        <p>Nothing</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </article>
      </div>
      <div class="cell is-flex">
        <article class="box is-flex-grow-1">
          <invoice-control v-if="selectedAssessments.length > 0"
            v-model="innerValue"
            :selected-invoice="selectedInvoice"
            :assessments="selectedAssessments"
            @raise-invoice="onRaiseInvoice"
            @merge-invoice="onMergeInvoice"
            @update-deductions="updateInvAmount"
            :is-orm-invoice-submitted="isOrmInvoiceSubmitted"
            :is-orm-payment-authorised="isOrmPaymentAuthorised"
            :is-orm-payment-declined="isOrmPaymentDeclined"
            :has-raised-invoice="hasRaisedInvoice" />
          <invoice-control-view v-else-if="selectedInvoice"
            v-model="innerValue"
            :selected-invoice="selectedInvoice"
            :cannot-void-invoice="cannotVoidInvoice"
            @void-invoice="deleteInvoice" />
          <div v-else>
            <p class="title">Invoice Control</p>
            <div class="content has-text-grey has-text-centered borderd-box pb-3">
              <span icon="icon is-large">
                <i class="mdi mdi-48px mdi-emoticon-sad" />
              </span>
              <p>Select a job to raise / view</p>
            </div>
          </div>
        </article>
      </div>

      <quote-detail-assessment-summary-modal v-if="isSummaryModalVisible"
        :show-icon="true"
        :active.sync="isSummaryModalVisible"
        :value="innerValue"
        @close="isSummaryModalVisible = false" />

      <BulmaMessage
        v-model="isGenerateInvoiceModalActive"
        type="is-info"
        title="Create New Invoice"
        :closable="true"
        @close="isGenerateInvoiceModalActive = false">
        <template #title>
          Create New Invoice
        </template>
        <!-- Disabled Items Section -->
        <div v-if="modalInvoices.some(assessment => assessment.isInvoiced)">
          <p class="is-size-7 has-text-grey mb-2">Already invoiced:</p>
          <div class="control is-flex justify-content-start">
            <div class="p-2"
              v-for="assessment in modalInvoices.filter(assessment => assessment.isInvoiced)"
              :key="assessment.subQuoteNo"
              style="opacity: 0.6;">
              <label class="checkbox toggle-style">
                <div class="pretty p-icon p-curve p-smooth m-0 p-bigger pr-1">
                  <input type="checkbox"
                    :value="assessment"
                    v-model="assessment.selected"
                    disabled>
                  <div class="state p-primary">
                    <i class="icon mdi mdi-check" />
                    <label />
                  </div>
                </div>
                {{ assessment.subQuoteNo === 0 ? 'Main' : `Supp-${assessment.subQuoteNo}` }}
              </label>
            </div>
          </div>
        </div>
        <div class="is-divider" />
        <p>Available for Invoicing: main / supplementaries</p>
        <!-- Enabled Items Section -->
        <div v-if="modalInvoices.some(assessment => !assessment.isInvoiced)"
          class="mb-4">
          <div class="control is-flex justify-content-start">
            <div class="p-2"
              v-for="assessment in modalInvoices.filter(assessment => !assessment.isInvoiced)"
              :key="assessment.subQuoteNo">
              <label class="checkbox toggle-style">
                <div class="pretty p-icon p-curve p-smooth m-0 p-bigger pr-1">
                  <input type="checkbox"
                    :value="assessment"
                    v-model="assessment.selected">
                  <div class="state p-primary">
                    <i class="icon mdi mdi-check" />
                    <label />
                  </div>
                </div>
                {{ assessment.subQuoteNo === 0 ? 'Main' : `Supp-${assessment.subQuoteNo}` }}
              </label>
            </div>
          </div>
        </div>
        <template #footer>
          <button
            class="button is-danger"
            @click="isGenerateInvoiceModalActive = false">
            Cancel
          </button>
          <button
            class="button is-primary"
            @click="handleAdd()">
            Add
          </button>
        </template>
      </BulmaMessage>
    </div>
  </div>
</template>

<script>
import { InvoiceControl, InvoiceControlView, QuoteDetailAssessmentSummaryModal } from './components'
import { InvoiceTypes } from '@/enums'
import _cloneDeep from 'lodash/cloneDeep'
import QuoteTotalsMethodMixin from './mixins/QuoteTotalsMethodMixin'
import { QuoteAssessmentMixin } from './mixins'
import { roundAwayFromZero } from '@/components/utils/AccountingFunctions'
import _isEqual from 'lodash/isEqual'
import BulmaMessage from '@/components/BulmaMessage/BulmaMessage.vue'
import { OrmQuoteStatusTypes } from '@/enums'

export default {
  name: 'QuoteAssessmentInvoice',
  components: {
    InvoiceControl,
    InvoiceControlView,
    QuoteDetailAssessmentSummaryModal,
    BulmaMessage
  },
  mixins: [QuoteTotalsMethodMixin, QuoteAssessmentMixin],
  props: {
    value: null,
    selectedInvoiceId: null,
    readOnlyView: {
      type: Boolean,
      default: false
    },
    animationIn: {
      type: String,
      default: 'fadeIn'
    },
    animationOut: {
      type: String,
      default: 'fadeOut'
    },
    animationDuration: {
      type: [String, Number],
      default: 0.3
    }
  },
  data() {
    return {
      innerValue: _cloneDeep(this.value),
      authorisedAssessments: [],
      selectedInvoice: null,
      columnsToBeInvoiced: ['Quote', 'Date Created', 'Quote Amount', 'Auth. Amount', 'Inv. Amount', 'Select'],
      columnsRaisedInvoices: ['Inv No.', 'Date Invoiced', 'Payer', 'Invoice Type', 'Inv. Amount'],
      isSummaryModalVisible: false,
      isGenerateInvoiceModalActive: false,
      modalInvoices: [],
      countShowGenerateInvoiceModal: 0,
      messages: []
    }
  },
  computed: {
    selectedAssessments() {
      return this.authorisedAssessments.filter((a) => a.selected)
    },
    toBeInvoiceAssessments() {
      return this.authorisedAssessments.filter((a) => !a.isInvoiced)
    },
    raisedInvoice() {
      return this.innerValue.invoices.filter((i) => i.isDeleted !== true && i.deleted !== true).sort((a, b) => b.invoiceNo - a.invoiceNo)
    },
    isOrmInvoiceSubmitted() {
      return this.innerValue && this.innerValue.orm && this.innerValue.orm.quoteStatusId === OrmQuoteStatusTypes.QuoteInvoiceSubmitted
    },
    isOrmPaymentAuthorised() {
      return this.innerValue && this.innerValue.orm && this.innerValue.orm.quoteStatusId === OrmQuoteStatusTypes.PaymentAuthorised
    },
    isOrmPaymentDeclined() {
      return this.innerValue && this.innerValue.orm && this.innerValue.orm.quoteStatusId === OrmQuoteStatusTypes.PaymentDeclined
    },
    isOrmReactiveInvoiceSubmitted() {
      return this.innerValue && this.innerValue.orm && this.innerValue.orm.quoteStatusId === OrmQuoteStatusTypes.ReactiveInvoiceSubmitted
    },
    isOrmAdjustmentNoteSubmitted() {
      return this.innerValue && this.innerValue.orm && this.innerValue.orm.quoteStatusId === OrmQuoteStatusTypes.AdjustmentNoteSubmitted
    },
    hasRaisedInvoice() {
      return this.raisedInvoice.length > 0
    },
    cannotRaiseInvoice() {
      return this.isOrmInvoiceSubmitted || this.isOrmReactiveInvoiceSubmitted || this.isOrmAdjustmentNoteSubmitted
    },
    isEstimage() {
      return this.value.isEstimage
    },
    cannotVoidInvoice() {
      if ((this.isOrmInvoiceSubmitted || this.isOrmPaymentAuthorised || this.isOrmReactiveInvoiceSubmitted || this.isOrmAdjustmentNoteSubmitted) && this.selectedInvoice) {
        const firstInvoice = this.innerValue.invoices
          .filter((i) => i.invoiceType === InvoiceTypes.Quote)
          .slice()
          .sort((a, b) => a.invoiceNo - b.invoiceNo)[0]
        if (!firstInvoice) {
          return false
        }
        return (this.selectedInvoice.invoiceId === firstInvoice.invoiceId)
      }
      return false
    }
  },
  watch: {
    value(newVal) {
      if (!_isEqual(newVal, this.innerValue)) {
        this.innerValue = _cloneDeep(newVal)
        this.setAuthorisedAssessments()
      }
    }
  },
  created() {
    this.innerValue = _cloneDeep(this.value)
    this.setAuthorisedAssessments()
    this.clearInvoiceSelection()
  },
  mounted() {
  },
  beforeDestroy() {},
  methods: {
    setAuthorisedAssessments() {
      this.authorisedAssessments = []
      const authorisedAssessment = this.innerValue.quoteAssessments.filter((a) => a.authorisedAssessment && !a.deleted)
      if (authorisedAssessment) {
        authorisedAssessment.forEach((assessment) => {
          assessment.authorisedAmount = this.getAssessmentItemsDeltaTotal(assessment.authorisedAssessment.assessmentQuoteItems, this.value.quotingMethod, this.isEstimage)
          assessment.quotedAmount = this.getAssessmentItemsDeltaTotal(assessment.submittedAssessment.assessmentQuoteItems, this.value.quotingMethod, this.isEstimage)
          this.$set(assessment, 'selected', false)
          this.$set(assessment, 'invoicedAmount', this.calculateInvoiceAmount(assessment))
          this.authorisedAssessments.push(assessment)
        })
      }
    },
    onAssessmentSelect(event, assessment) {
      const hasSupps = this.toBeInvoiceAssessments.some((a) => a.subQuoteNo > 0)
      if (this.countShowGenerateInvoiceModal == 0 && hasSupps && this.toBeInvoiceAssessments.length > 1) {
        event.preventDefault() // Prevents checkbox default

        var isRaisedInvoices = this.raisedInvoice.some((r) => r.invoiceType == 1).length > 0 //Quote invoice type
        this.modalInvoices = this.authorisedAssessments.map((item) => ({
          ...item,
          selected: !isRaisedInvoices ? true : item.isInvoiced ? true : item.assessmentID === assessment.assessmentID ? true : item.selected
        }))

        this.isGenerateInvoiceModalActive = true
        this.countShowGenerateInvoiceModal++
      } else {
        assessment.selected = event.target.checked
      }

      this.raisedInvoice.forEach((invoice) => {
        invoice.isSelected = false
      })
      this.selectedInvoice = null
    },
    // onAssessmentSelect(event, assessment) {
    //   if (event.target.checked) {
    //     assessment.selected = true
    //     // this.toBeInvoiceAssessments.forEach((a) => {
    //     //   if (a.subQuoteNo <= assessment.subQuoteNo) {
    //     //     a.selected = true
    //     //   }
    //     // })
    //   } else {
    //     // this.toBeInvoiceAssessments.forEach((a) => {
    //     //   if (a.subQuoteNo >= assessment.subQuoteNo) {
    //     //     a.selected = false
    //     //   }
    //     // })
    //     assessment.selected = false
    //   }
    //   this.raisedInvoice.forEach((invoice) => {
    //     invoice.isSelected = false
    //   })
    //   this.selectedInvoice = null
    // },
    onSelectInvoice(invoice) {
      this.raisedInvoice.forEach((invoice) => {
        invoice.isSelected = false
      })
      this.toBeInvoiceAssessments.forEach((a) => {
        a.selected = false
      })
      invoice.isSelected = !invoice.isSelected
      this.selectedInvoice = invoice
    },
    defaultSelect() {
      this.authorisedAssessments.forEach((assessment) => {
        assessment.selected = false
      })
    },
    calculateInvoiceAmount(assessment) {
      let invAmount = assessment.authorisedAmount
      if (assessment.subQuoteNo === 0) {
        let ownerContributionGst = 0
        if (!this.innerValue.excessWithGst) {
          ownerContributionGst = roundAwayFromZero((this.innerValue.ownersContribution * this.innerValue.gstRate) / 100)
        }
        invAmount = roundAwayFromZero(invAmount - this.innerValue.discount - this.innerValue.excess - this.innerValue.ownersContribution - ownerContributionGst)
      }
      return invAmount
    },
    updateInvAmount(deductions) {
      let mainAssessment = this.authorisedAssessments.find((a) => a.subQuoteNo === 0)
      if (mainAssessment) {
        mainAssessment.invoicedAmount = mainAssessment.authorisedAmount - deductions
      }
    },
    onRaiseInvoice(invoices) {
      this.$emit('input', this.innerValue)
      this.innerValue.invoices.push(...invoices)
      this.selectedAssessments.forEach((assessment) => {
        assessment.isInvoiced = true
      })
      this.saveQuote()
      this.countShowGenerateInvoiceModal = 0
    },
    onMergeInvoice(invoices) {
      const existingMainInvoice = this.innerValue.invoices.find(
        (i) => i.invoiceType === InvoiceTypes.Quote && !i.deleted && !i.isDeleted
      )

      if (existingMainInvoice) {
        const newInvoice = invoices.find((inv) => inv.invoiceType === InvoiceTypes.Quote)

        if (newInvoice) {
          const currentIds = existingMainInvoice.includedAssessments || []
          const newIds = newInvoice.includedAssessments || []
          const mergedIds = Array.from(new Set([...currentIds, ...newIds]))
          existingMainInvoice.includedAssessments = mergedIds

          const includedAssessments = this.authorisedAssessments.filter((a) =>
            mergedIds.includes(a.assessmentID)
          )
          const totalAuthorised = includedAssessments.reduce(
            (total, a) => total + (a.authorisedAmount || 0),
            0
          )

          let ownerContributionGst = 0
          if (!this.innerValue.excessWithGst) {
            ownerContributionGst = roundAwayFromZero(
              (this.innerValue.ownersContribution * this.innerValue.gstRate) / 100
            )
          }

          const deductionAmount =
            this.innerValue.discount +
            this.innerValue.excess +
            this.innerValue.ownersContribution +
            ownerContributionGst

          existingMainInvoice.totalExGst = roundAwayFromZero(totalAuthorised - deductionAmount)

          if (!this.innerValue.excessWithGst) {
            existingMainInvoice.gst = roundAwayFromZero(
              ((totalAuthorised - this.innerValue.discount) * this.innerValue.gstRate) / 100
            )
          } else {
            existingMainInvoice.gst = roundAwayFromZero(
              (existingMainInvoice.totalExGst * existingMainInvoice.gstRate) / 100
            )
          }

          existingMainInvoice.totalIncGst = roundAwayFromZero(
            existingMainInvoice.totalExGst + existingMainInvoice.gst
          )

          existingMainInvoice.labourTotal = roundAwayFromZero(
            (existingMainInvoice.labourTotal || 0) + (newInvoice.labourTotal || 0)
          )
          existingMainInvoice.partTotal = roundAwayFromZero(
            (existingMainInvoice.partTotal || 0) + (newInvoice.partTotal || 0)
          )
          existingMainInvoice.miscTotal = roundAwayFromZero(
            (existingMainInvoice.miscTotal || 0) + (newInvoice.miscTotal || 0)
          )
          existingMainInvoice.subletTotal = roundAwayFromZero(
            (existingMainInvoice.subletTotal || 0) + (newInvoice.subletTotal || 0)
          )
          existingMainInvoice.rrTotal = roundAwayFromZero(
            (existingMainInvoice.rrTotal || 0) + (newInvoice.rrTotal || 0)
          )
          existingMainInvoice.repairTotal = roundAwayFromZero(
            (existingMainInvoice.repairTotal || 0) + (newInvoice.repairTotal || 0)
          )
          existingMainInvoice.paintTotal = roundAwayFromZero(
            (existingMainInvoice.paintTotal || 0) + (newInvoice.paintTotal || 0)
          )
          existingMainInvoice.mechTotal = roundAwayFromZero(
            (existingMainInvoice.mechTotal || 0) + (newInvoice.mechTotal || 0)
          )
          existingMainInvoice.opgTotal = roundAwayFromZero(
            (existingMainInvoice.opgTotal || 0) + (newInvoice.opgTotal || 0)
          )
          existingMainInvoice.fgTotal = roundAwayFromZero(
            (existingMainInvoice.fgTotal || 0) + (newInvoice.fgTotal || 0)
          )
          existingMainInvoice.crushTotal = roundAwayFromZero(
            (existingMainInvoice.crushTotal || 0) + (newInvoice.crushTotal || 0)
          )
          existingMainInvoice.cdTotal = roundAwayFromZero(
            (existingMainInvoice.cdTotal || 0) + (newInvoice.cdTotal || 0)
          )
          existingMainInvoice.rwaTotal = roundAwayFromZero(
            (existingMainInvoice.rwaTotal || 0) + (newInvoice.rwaTotal || 0)
          )
        }

        const newGstInvoice = invoices.find((inv) => inv.invoiceType === InvoiceTypes.Gst)
        const existingGstInvoice = this.innerValue.invoices.find(
          (i) => i.invoiceType === InvoiceTypes.Gst && !i.deleted && !i.isDeleted
        )

        if (newGstInvoice) {
          if (existingGstInvoice) {
            existingGstInvoice.gst = existingMainInvoice.gst
            existingGstInvoice.totalIncGst = existingMainInvoice.gst
            existingGstInvoice.includedAssessments = existingMainInvoice.includedAssessments
          } else {
            this.innerValue.invoices.push(newGstInvoice)
          }
        }

        this.selectedAssessments.forEach((assessment) => {
          assessment.isInvoiced = true
        })

        this.saveQuote()
      }
    },
    deleteInvoice(invoices) {
      invoices.forEach((invoice) => {
        invoice.deleted = true
        invoice.isDeleted = true
        invoice.isSelected = false
        this.selectedInvoice = null
        this.authorisedAssessments.forEach((a) => {
          if (invoice.includedAssessments.some((i) => i === a.assessmentID)) {
            a.isInvoiced = false
            a.selected = false
          }
        })
      })
      this.saveQuote()
    },
    saveQuote() {
      this.$emit('input', this.innerValue)
      this.$emit('save')
    },
    openSummaryModal() {
      this.isSummaryModalVisible = true
    },
    invoiceTypeName(invoiceType) {
      return InvoiceTypes.getDisplayName(invoiceType)
    },
    clearInvoiceSelection() {
      this.innerValue.invoices.forEach((invoice) => {
        invoice.isSelected = false
      })
      if (this.selectedInvoiceId) {
        this.selectedInvoice = this.innerValue.invoices.find((i) => i.invoiceId === this.selectedInvoiceId)
      } else if (this.innerValue.invoices.length > 0) {
        this.innerValue.invoices[this.innerValue.invoices.length - 1].isSelected = true
        this.selectedInvoice = this.innerValue.invoices[this.innerValue.invoices.length - 1]
      }
    },
    handleAdd() {
      this.toBeInvoiceAssessments.forEach((item) => {
        const matched = this.modalInvoices.find((modal) => modal.assessmentID === item.assessmentID)
        item.selected = matched ? matched.selected : false
      })
      this.isGenerateInvoiceModalActive = false
    }
  }
}
</script>

<style lang="scss" scoped>
.is-size-8 {
  font-size: 0.65rem !important;
}
.borderd-box {
  border: 1px solid gainsboro;
}
</style>
